export default "__VITE_ASSET__D2JpJrjh__"